import { render, staticRenderFns } from "./ImageDropzone.vue?vue&type=template&id=6e3da6e1"
import script from "./ImageDropzone.vue?vue&type=script&lang=js"
export * from "./ImageDropzone.vue?vue&type=script&lang=js"
import style0 from "./ImageDropzone.vue?vue&type=style&index=0&id=6e3da6e1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports